const fn = {
    init: () => {
        if ($('.preloader').length) {
            $('.preloader').fadeOut('slow');
        }
    }
}

export default {
    can: () => true,
    run: fn.init,
};
